import { PaginatedColumn } from '../types/app';

export const TABLE_COLUMNS_NAME: PaginatedColumn[] = [
  {
    label: 'Placa ó Identificador',
    key: 'plate',
    minWidth: 200,
    maxWidth: 300,
  },
  {
    label: 'Etiqueta',
    key: 'label',
    minWidth: 300,
  },
  {
    label: 'Estatus',
    key: 'status',
    minWidth: 100,
    maxWidth: 100,
  },
  {
    label: 'Regla',
    key: 'rule',
    minWidth: 300,
  },
  {
    label: 'Último Mantenimiento',
    key: 'lastMaintenanceDate',
    minWidth: 160,
    maxWidth: 160,
  },
  {
    label: 'Último Kilometraje',
    key: 'lastMaintenanceMileage',
    minWidth: 150,
    maxWidth: 150,
  },
  {
    label: 'Siguiente Servicio',
    key: 'nextServiceDate',
    minWidth: 135,
    maxWidth: 135,
  },
  {
    label: 'Acciones',
    key: 'actions',
    minWidth: 120,
    maxWidth: 120,
    centered: true,
  },
];
